<template>
  <sub-page title="我的信息">
    <div :class="['info-page', { 'form-active': activeTab === 0 }]">
      <!-- 顶部页签：基础信息/学历信息/职称信息/技能信息 -->
      <div class="tab-bar">
        <div
          class="tab-item"
          v-for="(tab, idx) in tabs"
          :key="tab"
          :class="{ active: activeTab === idx }"
          @click="activeTab = idx"
        >{{ tab }}</div>
        <div class="tab-indicator" :style="indicatorStyle">
          <div class="indicator-inner"></div>
        </div>
      </div>

      <!-- 基础信息：表单（含只读/选择/输入三类字段） -->
      <div class="base-form" v-show="activeTab === 0">
        <div class="form-item" v-for="f in fields" :key="f.key">
          <span :class="['form-label', { required: f.required, readonly: f.type === 'ro' }]">{{ f.label }}</span>
          <input
            v-if="f.type === 'input'"
            v-model="form[f.key]"
            class="form-input"
          />
          <span
            v-else
            :class="['form-value', { readonly: f.type === 'ro' }]"
            @click="openSheet(f)"
          >{{ form[f.key] }}</span>
        </div>
      </div>

      <!-- 学历信息：卡片列表 -->
      <div class="card-list" v-show="activeTab === 1">
        <div class="info-card" v-for="(c, i) in eduList" :key="i">
          <div class="card-title">{{ c.degree }}</div>
          <div class="card-row">院校名称：{{ c.school }}</div>
          <div class="card-row card-dates">
            <span class="date-col">入学日期：{{ c.inDate }}</span>
            <span class="date-col">毕业日期：{{ c.outDate }}</span>
          </div>
          <div class="card-row">学历学制：{{ c.system }}</div>
        </div>
      </div>

      <!-- 职称信息：卡片列表 -->
      <div class="card-list" v-show="activeTab === 2">
        <div class="info-card" v-for="(c, i) in titleList" :key="'t' + i">
          <div class="card-title">{{ c.name }}</div>
          <div class="card-row">职称级别：{{ c.level }}</div>
          <div class="card-row">取得日期：{{ c.date }}</div>
          <div class="card-row">证书编号：{{ c.certNo }}</div>
        </div>
      </div>

      <!-- 技能信息：卡片列表 -->
      <div class="card-list" v-show="activeTab === 3">
        <div class="info-card" v-for="(c, i) in skillList" :key="'s' + i">
          <div class="card-title">{{ c.name }}</div>
          <div class="card-row">技能等级：{{ c.level }}</div>
          <div class="card-row">取得日期：{{ c.date }}</div>
          <div class="card-row">证书编号：{{ c.certNo }}</div>
        </div>
      </div>

      <!-- 底部主按钮：基础信息为保存，其余页签为新增 -->
      <div class="footer">
        <button class="main-btn" v-if="activeTab === 0" @click="handleSave">保存</button>
        <button class="main-btn" v-else @click="openAdd">
          <svg viewBox="0 0 24 24" class="plus-icon"><path d="M12 5v14M5 12h14" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/></svg>
          新增
        </button>
      </div>

      <!-- 新增信息表单弹窗 -->
      <div class="add-mask" v-if="addModal.show" @click="addModal.show = false">
        <div class="add-dialog" @click.stop>
          <div class="add-title">{{ addModal.title }}</div>
          <div class="add-body">
            <div class="add-item" v-for="f in addModal.fields" :key="f.key">
              <span class="add-label">{{ f.label }}</span>
              <input
                v-if="f.type === 'input'"
                v-model="addModal.data[f.key]"
                class="add-input"
                :placeholder="f.placeholder || '请输入'"
              />
              <div v-else class="add-picker" @click="openAddSheet(f)">
                <span :class="['add-picker-value', { placeholder: !addModal.data[f.key] }]">{{ addModal.data[f.key] || '请选择' }}</span>
                <svg viewBox="0 0 24 24" class="add-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
            </div>
          </div>
          <div class="add-btns">
            <button class="add-btn" @click="addModal.show = false">取消</button>
            <button class="add-btn primary" @click="confirmAdd">确定</button>
          </div>
        </div>
      </div>

      <!-- 字段选择 -->
      <field-sheet
        :show="sheet.show"
        :title="sheet.title"
        :options="sheet.options"
        :value="sheet.value"
        @select="onSheetSelect"
        @close="sheet.show = false"
      />
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'
import FieldSheet from '@/components/FieldSheet.vue'

export default {
  name: 'MyInfo',
  components: { SubPage, FieldSheet },
  data() {
    return {
      tabs: ['基础信息', '学历信息', '职称信息', '技能信息'],
      activeTab: 0,
      form: {
        personNo: '1132752733',
        provinceNo: 'JSA102347013',
        certType: '居民身份证',
        certNo: '34*************19',
        name: '**杰',
        gender: '男',
        ssNo: '34*************19',
        phone: '17366188469',
        nationality: '中国',
        nation: '汉族',
        politics: '',
        occupation: '',
        address: '安徽省来安县新安镇十里村磨桥组33号',
        hujiType: '本省城镇',
        hujiRegion: '江苏省/南京市/栖霞区',
        hujiAddress: '经济技术开发区分局新港派出所'
      },
      // ro=只读（置灰） select=底部操作表选择 input=文本输入
      fields: [
        { label: '个人编号', key: 'personNo', type: 'ro' },
        { label: '省人员识别号', key: 'provinceNo', type: 'ro' },
        { label: '证件类型', key: 'certType', type: 'select', required: true, options: ['居民身份证', '护照', '港澳居民来往内地通行证', '台湾居民来往大陆通行证'] },
        { label: '证件号码', key: 'certNo', type: 'ro' },
        { label: '姓名', key: 'name', type: 'input', required: true },
        { label: '性别', key: 'gender', type: 'select', required: true, options: ['男', '女'] },
        { label: '社会保障号码', key: 'ssNo', type: 'ro' },
        { label: '移动电话', key: 'phone', type: 'input', required: true },
        { label: '国籍/地区', key: 'nationality', type: 'select', required: true, options: ['中国', '中国香港', '中国澳门', '中国台湾', '其他'] },
        { label: '民族', key: 'nation', type: 'select', required: true, options: ['汉族', '回族', '满族', '壮族', '其他'] },
        { label: '政治面貌', key: 'politics', type: 'ro' },
        { label: '职业', key: 'occupation', type: 'select', required: true, options: ['国家机关负责人', '专业技术人员', '办事人员和有关人员', '社会生产服务人员', '农林牧渔生产人员', '生产制造人员', '军人', '其他人员'] },
        { label: '居住地址', key: 'address', type: 'input', required: true },
        { label: '户籍性质', key: 'hujiType', type: 'select', required: true, options: ['本省城镇', '本省农村', '外省城镇', '外省农村'] },
        { label: '户籍地行政区划', key: 'hujiRegion', type: 'select', required: true, options: ['江苏省/南京市/栖霞区', '江苏省/南京市/玄武区', '江苏省/南京市/鼓楼区', '江苏省/苏州市/姑苏区', '江苏省/无锡市/梁溪区', '安徽省/滁州市/来安县', '安徽省/合肥市/蜀山区'] },
        { label: '户籍地址', key: 'hujiAddress', type: 'input', required: true }
      ],
      eduList: [
        { degree: '大学本科', school: '巢湖学院', inDate: '20120901', outDate: '20160701', system: '' }
      ],
      titleList: [],
      skillList: [],
      // 各页签「新增」弹窗表单配置（required 为必填项）
      addConfigs: {
        学历信息: {
          title: '新增学历信息',
          fields: [
            { label: '学历', key: 'degree', type: 'select', required: true, options: ['博士研究生', '硕士研究生', '大学本科', '大学专科', '中职（中专/技校/职高）'] },
            { label: '院校名称', key: 'school', type: 'input', required: true },
            { label: '入学日期', key: 'inDate', type: 'input', placeholder: '如 20120901' },
            { label: '毕业日期', key: 'outDate', type: 'input', placeholder: '如 20160701' },
            { label: '学历学制', key: 'system', type: 'input', placeholder: '如 四年' }
          ]
        },
        职称信息: {
          title: '新增职称信息',
          fields: [
            { label: '职称名称', key: 'name', type: 'input', required: true },
            { label: '职称级别', key: 'level', type: 'select', required: true, options: ['员级', '助理级', '中级', '副高级', '正高级'] },
            { label: '取得日期', key: 'date', type: 'input', placeholder: '如 20200101' },
            { label: '证书编号', key: 'certNo', type: 'input' }
          ]
        },
        技能信息: {
          title: '新增技能信息',
          fields: [
            { label: '技能名称', key: 'name', type: 'input', required: true },
            { label: '技能等级', key: 'level', type: 'select', required: true, options: ['初级工', '中级工', '高级工', '技师', '高级技师'] },
            { label: '取得日期', key: 'date', type: 'input', placeholder: '如 20200101' },
            { label: '证书编号', key: 'certNo', type: 'input' }
          ]
        }
      },
      addModal: { show: false, title: '', fields: [], data: {} },
      sheet: { show: false, title: '', options: [], value: '', key: '', target: 'form' }
    }
  },
  computed: {
    // 页签指示条：整体宽度为 1/4，通过位移实现平滑滑动
    indicatorStyle() {
      return {
        transform: 'translateX(' + this.activeTab * 100 + '%)'
      }
    }
  },
  methods: {
    openSheet(f) {
      if (f.type !== 'select') return
      this.sheet = { show: true, title: '请选择' + f.label, options: f.options, value: this.form[f.key], key: f.key, target: 'form' }
    },
    openAddSheet(f) {
      this.sheet = { show: true, title: '请选择' + f.label, options: f.options, value: this.addModal.data[f.key], key: f.key, target: 'add' }
    },
    onSheetSelect(val) {
      if (this.sheet.target === 'add') {
        this.addModal.data[this.sheet.key] = val
      } else {
        this.form[this.sheet.key] = val
      }
      this.sheet.show = false
    },
    // 保存基础信息：校验必填项与手机号格式
    handleSave() {
      for (const f of this.fields) {
        if (!f.required || f.type === 'ro') continue
        const v = String(this.form[f.key] || '').trim()
        if (!v) {
          this.$alert((f.type === 'select' ? '请选择' : '请输入') + f.label)
          return
        }
      }
      if (!/^1[3-9]\d{9}$/.test(String(this.form.phone).trim())) {
        this.$alert('请输入正确的移动电话')
        return
      }
      this.$alert('保存成功')
    },
    // 打开对应页签的新增弹窗（预置空字段保证 Vue2 响应式）
    openAdd() {
      const conf = this.addConfigs[this.tabs[this.activeTab]]
      const data = {}
      conf.fields.forEach(f => { data[f.key] = '' })
      this.addModal = { show: true, title: conf.title, fields: conf.fields, data }
    },
    // 确认新增：校验后写入对应列表并关闭弹窗
    confirmAdd() {
      const tab = this.tabs[this.activeTab]
      const d = this.addModal.data
      for (const f of this.addModal.fields) {
        if (f.required && !String(d[f.key] || '').trim()) {
          this.$alert((f.type === 'select' ? '请选择' : '请输入') + f.label)
          return
        }
      }
      const dateKeys = ['inDate', 'outDate', 'date']
      for (const k of dateKeys) {
        if (d[k] && !/^\d{8}$/.test(String(d[k]).trim())) {
          this.$alert('日期格式应为8位数字，如 20120901')
          return
        }
      }
      if (tab === '学历信息') {
        this.eduList.unshift({ degree: d.degree, school: d.school, inDate: d.inDate, outDate: d.outDate, system: d.system })
      } else if (tab === '职称信息') {
        this.titleList.unshift({ name: d.name, level: d.level, date: d.date, certNo: d.certNo })
      } else {
        this.skillList.unshift({ name: d.name, level: d.level, date: d.date, certNo: d.certNo })
      }
      this.addModal.show = false
    }
  }
}
</script>

<style scoped>
.info-page {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #F5F5F5;
}
/* 基础信息页签为白底表单 */
.info-page.form-active {
  background: #fff;
}

/* 页签栏 */
.tab-bar {
  /* 覆盖 App.vue 泄漏的全局 .tab-bar 规则（height:150/grid），否则页签栏被撑高、文字贴顶 */
  height: calc(64 * var(--w));
  position: relative;
  display: flex;
  background: #fff;
  border-bottom: 1px solid #ebebeb;
  flex-shrink: 0;
}
.tab-item {
  flex: 1;
  height: calc(64 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: calc(28 * var(--w));
  line-height: 1;
  /* RSJ Sans 字框基线偏下，汉字墨迹视觉偏下约0.5px，微移补偿使上下间距对称 */
  transform: translateY(calc(-1.4 * var(--w)));
  color: #323233;
  cursor: pointer;
}
.tab-item.active {
  color: #D88230;
}
.tab-indicator {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 25%;
  display: flex;
  justify-content: center;
  transition: transform 0.25s ease;
}
.indicator-inner {
  width: calc(60 * var(--w));
  height: calc(5 * var(--w));
  border-radius: calc(2.5 * var(--w));
  background: #D88230;
}

/* 基础信息表单 */
.base-form {
  background: #fff;
}
.form-item {
  display: flex;
  align-items: center;
  min-height: calc(84 * var(--w));
  padding: 0 calc(32 * var(--w));
  border-bottom: 1px solid #F0F0F0;
}
.form-item:last-child {
  border-bottom: none;
}
.form-label {
  width: calc(210 * var(--w));
  flex-shrink: 0;
  font-size: calc(28 * var(--w));
  color: #323233;
  line-height: 1.35;
}
.form-label.required::before {
  content: '*';
  color: #f00;
  margin-right: calc(4 * var(--w));
}
.form-label.readonly {
  color: #969799;
}
.form-value {
  flex: 1;
  font-size: calc(28 * var(--w));
  color: #323233;
  line-height: 1.35;
  cursor: pointer;
}
.form-value.readonly {
  color: #969799;
  cursor: default;
}
.form-input {
  flex: 1;
  height: calc(84 * var(--w));
  border: none;
  outline: none;
  background: transparent;
  font-size: calc(28 * var(--w));
  color: #323233;
}

/* 学历信息卡片 */
.card-list {
  padding: calc(24 * var(--w)) calc(24 * var(--w)) 0;
}
.info-card {
  background: #fff;
  border-radius: calc(8 * var(--w));
  padding: calc(28 * var(--w)) calc(32 * var(--w));
}
.info-card + .info-card {
  margin-top: calc(24 * var(--w));
}
.card-title {
  font-size: calc(32 * var(--w));
  color: #323233;
  font-weight: 500;
  margin-bottom: calc(20 * var(--w));
}
.card-row {
  font-size: calc(28 * var(--w));
  color: #646566;
  line-height: calc(52 * var(--w));
}
.card-dates {
  display: flex;
}
.date-col {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 底部主按钮：内容不满一屏时贴底展示 */
.footer {
  margin-top: auto;
  padding: calc(40 * var(--w)) calc(32 * var(--w)) calc(40 * var(--w));
}
.main-btn {
  width: 100%;
  height: calc(88 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2E8CF6;
  color: #fff;
  font-size: calc(34 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
.main-btn:active {
  opacity: 0.9;
}
.plus-icon {
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
  margin-right: calc(10 * var(--w));
}

/* 新增信息表单弹窗（层级低于 FieldSheet 200，保证弹窗内可再弹选择表） */
.add-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 150;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-dialog {
  width: calc(630 * var(--w));
  background: #fff;
  border-radius: calc(16 * var(--w));
  overflow: hidden;
}
.add-title {
  text-align: center;
  font-size: calc(34 * var(--w));
  font-weight: 500;
  color: #323233;
  padding: calc(32 * var(--w)) 0 calc(8 * var(--w));
}
.add-body {
  padding: 0 calc(32 * var(--w));
  max-height: calc(680 * var(--w));
  overflow-y: auto;
}
.add-item {
  display: flex;
  align-items: center;
  min-height: calc(88 * var(--w));
  border-bottom: 1px solid #f0f0f0;
  gap: calc(20 * var(--w));
}
.add-item:last-child {
  border-bottom: none;
}
.add-label {
  width: calc(140 * var(--w));
  flex-shrink: 0;
  font-size: calc(28 * var(--w));
  color: #323233;
}
.add-input {
  flex: 1;
  height: calc(88 * var(--w));
  border: none;
  outline: none;
  font-size: calc(28 * var(--w));
  color: #323233;
  background: transparent;
}
.add-input::placeholder {
  color: #c8c9cc;
}
.add-picker {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.add-picker-value {
  font-size: calc(28 * var(--w));
  color: #323233;
}
.add-picker-value.placeholder {
  color: #c8c9cc;
}
.add-arrow {
  width: calc(28 * var(--w));
  height: calc(28 * var(--w));
  flex-shrink: 0;
}
.add-btns {
  display: flex;
  border-top: 1px solid #f0f0f0;
  margin-top: calc(8 * var(--w));
}
.add-btn {
  flex: 1;
  height: calc(88 * var(--w));
  background: #fff;
  border: none;
  font-size: calc(32 * var(--w));
  color: #646566;
  cursor: pointer;
}
.add-btn.primary {
  color: #2E8CF6;
}
.add-btn:active {
  background: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/pages/MyInfo.vue